import React from "react"
import {makeStyles} from "@material-ui/core/styles"
import {useTranslation} from "react-i18next"
import {Avatar, Typography} from "@material-ui/core"
import {useStore} from "../Store"
import "../i18n"

const useStyles = makeStyles(() => ({
  root: {
    height: 88,
  },
  container: {
    display: `flex`,
  },
  avatar: {
    display: `flex`,
    width: 48,
    height: 48,
    margin: `20px 8px`,
  },
  user: {
    margin: `32px 4px`,
  },
}))

export default function NavHeaderEx({collapsed}) {
  const {t} = useTranslation()
  const {store: {userInfo}} = useStore()
  const classes = useStyles()

  if (!userInfo) return null

  const avator = (
    <div className={classes.container}>
      <Avatar className={classes.avatar} src={userInfo.picture} />
      {!collapsed && <Typography className={classes.user}>{userInfo.name}</Typography>}
    </div>
  )

  return (
    <div className={classes.root}>
      {avator}
    </div>
  )
}
